import React, { useState, useCallback } from 'react';
import Card from 'components/cards/Card01';
import Datepicker from 'components/actions/DatePicker';
import AnalyticsSerive from 'api/services/AnalyticsService';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from "react-i18next";
import { getChannelLanguageString, getDateRangeString, getI18nValue } from 'utils/Utils';
import { useAxios } from 'hooks/useAxios';
import ChannelSelect from './ChannelSelect';
import { ExportCSV } from 'components/ExportCSV';

function MessagesByLanguage() {
    const { t } = useTranslation();

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );

    const [channel, setChannel] = useState('');
    const language = '';

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(AnalyticsSerive.getMessagesByLanguage(selectedDateRanges, channel, language))

    return (


        <div className='p-4 col-span-full  md:col-span-6 xl:col-span-6 bg-white shadow-sm rounded-sm border border-gray-200 min-h-[480px]'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-blue-100 mb-4 flex-wrap ">
                <div className='mb-4'>
                    <header className='capitalize text-xl font-semibold text-gray-800'>{t(getI18nValue('analytics.messages_by_language', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.messages_by_language', "description"))}</p>
                </div>
                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`messagesByLanguage_${getDateRangeString(selectedDateRanges) + getChannelLanguageString(channel, language)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="cards" isEmpty={!loading && !data}>
                <div className="grid grid-cols-2 xl:grid-cols-2 gap-y-2 gap-x-2" >
                    {!!data && Object.entries(data).map((item, i) => {
                        return (
                            <div key={item[0]} className=''>
                                <Card
                                    title={t(getI18nValue(`analytics.messages_by_language.${item[0]}`, "title"))}
                                    description={t(getI18nValue(`analytics.messages_by_language.${item[0]}`, "description"))}
                                    value={item[1]}
                                    icon={getIcon(item[0])}
                                />
                            </div>

                        )
                    })}
                </div>
            </LayoutWrapper>


        </div >
    );
}


export default MessagesByLanguage;


const getIcon = (key) => {
    let iconList = {
        'arabic': <div className='w-5 h-5 text-blue-500 text-center text-sm font-bold'>AR</div>,
        'arabic_dialect_ma': <div className='w-5 h-5 text-blue-500 text-center text-sm font-bold'>AR</div>,
        'french': <div className='w-5 h-5 text-blue-500 text-center text-sm font-bold'>FR</div>,
        'english': <div className='w-5 h-5 text-blue-500 text-center text-sm font-bold'>EN</div>,
        'default': <div className='w-5 h-5' />
    };
    return (iconList[key] || iconList['default']);
}